"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _pageManager = _interopRequireDefault(require("./page-manager"));
var _constants = require("../constants/constants");
var _bwaDeliveryPill = _interopRequireDefault(require("../components/bwa-delivery-pill/bwa-delivery-pill"));
var _bwaCheckoutButton = _interopRequireDefault(require("../components/bwa-checkout-button/bwa-checkout-button"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var HomePage = /*#__PURE__*/function (_PageManager) {
  function HomePage() {
    (0, _classCallCheck2["default"])(this, HomePage);
    return _callSuper(this, HomePage);
  }
  (0, _inherits2["default"])(HomePage, _PageManager);
  return (0, _createClass2["default"])(HomePage, [{
    key: "onPageLoad",
    value: function () {
      var _onPageLoad = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var validateStoreResponse;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              validateStoreResponse = window.bwaValidateStoreResponse;
              if (validateStoreResponse !== null && validateStoreResponse !== void 0 && validateStoreResponse.isStoreBwAEnabled) {
                sessionStorage.setItem(_constants.SESSION_STORAGE_KEYS.CLIENT_ID, validateStoreResponse.clientId);
              }
              new _bwaDeliveryPill["default"]();
              new _bwaCheckoutButton["default"]();
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function onPageLoad() {
        return _onPageLoad.apply(this, arguments);
      }
      return onPageLoad;
    }()
  }]);
}(_pageManager["default"]);
var _default = exports["default"] = HomePage;
//# sourceMappingURL=home.js.map
